module.exports = __webpack_public_path__ + "static/media/geewin-exim.dc058083.png";